import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/products/new',
  title: 'title',
  endpoint: '/app/store_product',
}
